import { LeaveCondition } from '@Managers/StateMachine/LeaveCondition';
import { EWinPresentationStates } from './WinPresentationStates';

export type TWinPresentationStateConditionsNames =
    | 'winPresentationHiddenCondition'
    | 'winPresentationInCondition'
    | 'winPresentationIdleCondition'
    | 'winPresentationOutCondition'
    | 'winPresentationHoldCondition';

export const WinPresentationStateConditions: { [K in TWinPresentationStateConditionsNames]: LeaveCondition<EWinPresentationStates> } = {
    // LEAVE CONDITIONS - HIDDEN
    winPresentationHiddenCondition: new LeaveCondition('waitForWinState', EWinPresentationStates.WIN_PRESENTATION_HIDDEN_STATE),

    // LEAVE CONDITIONS - WIN
    winPresentationInCondition: new LeaveCondition('waitForWinInAnimationOrUserInteraction', EWinPresentationStates.WIN_PRESENTATION_IN_STATE),
    winPresentationIdleCondition: new LeaveCondition('waitForWinAnimationOrUserInteraction', EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE),
    winPresentationOutCondition: new LeaveCondition('waitForWinOutAnimationOrUserInteraction', EWinPresentationStates.WIN_PRESENTATION_OUT_STATE),

    // LEAVE CONDITIONS - WIN HOLD
    winPresentationHoldCondition: new LeaveCondition('waitForTimerOrUserInteraction', EWinPresentationStates.WIN_PRESENTATION_HOLD_STATE)
};
